export default __webpack_public_path__ + "static/media/checkBoxPass.5e540309.svg";